import {
  any,
  array,
  boolean,
  coerce,
  create,
  Describe,
  nullable,
  number,
  record,
  string,
  type,
  union,
} from 'superstruct';

import { FieldSettings } from '~extension/web2print/model/FieldSettings';
import { FormSettings } from '~extension/web2print/model/FormSettings';

export const FieldSettingsValidator: Describe<FieldSettings> = type({
  key: string(),
  type: string(),
  label: string(),
  fieldname: string(),
  value: union([nullable(string()), number(), array(number())]),
  options: nullable(union([record(string(), any()), array(any())])),
  required: boolean(),
  tooltip: nullable(string()),
});

export const FormSettingsValidator: Describe<FormSettings> = type({
  assetId: coerce(nullable(string()), number(), value => String(value)),
  fields: array(FieldSettingsValidator),
  showIntro: boolean(),
  status: string(),
  message: string(),
});

export function makeFormSettings(raw: unknown) {
  try {
    const formSettings = create(raw, FormSettingsValidator);
    return formSettings;
  } catch (err) {
    console.error(err);
  }
}
